import { module } from 'modujs'
import gsap from "gsap";

export default class extends module {
    constructor(m) {
        super(m);
        this.mouseMove = this.manageMouseMove.bind(this)
        this.mouseClick = this.manageMouseClick.bind(this)
        this.mouseOver = this.manageMouseOver.bind(this)
        this.mouseLeave = this.manageMouseLeave.bind(this)
        this.resize = this.manageResize.bind(this)
        this.$container = this.$("container")[0]
        this.$soundIcon = this.$("sound-icon")[0]
        this.$audio = this.$("audio")[0];
        this.$soundIconMoving = this.$("sound-icon-moving")[0]
        this.audioEnded = this.manageAudioEnded.bind(this)
        this.xTo = gsap.quickTo(this.$soundIconMoving, "left", { duration: 0.75, ease: "power3"})
        this.yTo = gsap.quickTo(this.$soundIconMoving, "top", { duration: 0.75, ease: "power3"})
    }

    init() {
        window.addEventListener("resize", this.resize);
        this.$container.addEventListener("click", this.mouseClick);
        this.$soundIcon.addEventListener("click", this.mouseClick);
        this.$audio.addEventListener("ended", this.audioEnded)
        this.manageResize();
    }

    destroy() {
        this.$container.removeEventListener("click", this.mouseClick)
        this.$soundIcon.removeEventListener("click", this.mouseClick);
        window.removeEventListener("resize", this.resize)
        this.$container.removeEventListener("mouseenter", this.mouseOver);
        this.$container.removeEventListener("mouseleave", this.mouseLeave);
        window.removeEventListener("mousemove", this.mouseMove);
    }

    manageAudioEnded() {
        this.$soundIconMoving.classList.remove("-active")
        this.$soundIcon.classList.remove("-active")
        this.$soundIcon.setAttribute('aria-label', this.$soundIcon.getAttribute('data-aria-play'));
        this.$soundIconMoving.setAttribute('aria-label', this.$soundIcon.getAttribute('data-aria-play'));
    }

    manageMouseMove(e) {
        const { clientX, clientY } = e;
        this.xTo(clientX - 65);
        this.yTo(clientY - 65);
    }

    manageMouseOver() {
        gsap.to(this.$soundIcon, {scale: 0, duration: 0.33})
        gsap.to(this.$soundIconMoving, {display: "flex", scale: 1, duration: 0.33})
    }

    manageMouseLeave() {
        gsap.to(this.$soundIcon, {scale: 1, duration: 0.33})
        gsap.to(this.$soundIconMoving, {scale: 0, duration: 0.33, onComplete: () => {
            gsap.set(this.$soundIconMoving, {display: "none"})
        }})
    }

    manageMouseClick() {
        const classes = [...this.$soundIcon.classList];
        if(classes.includes("-active")){
            //toggle sound to true
            this.$soundIconMoving.classList.remove("-active")
            this.$soundIcon.classList.remove("-active")
            this.$audio.pause();
            this.$soundIcon.setAttribute('aria-label', this.$soundIcon.getAttribute('data-aria-play'));
            this.$soundIconMoving.setAttribute('aria-label', this.$soundIcon.getAttribute('data-aria-play'));
        }
        else{
            //toggle sound to false
            this.$audio.play();
            this.$soundIconMoving.classList.add("-active")
            this.$soundIcon.classList.add("-active")
            this.$soundIcon.setAttribute('aria-label', this.$soundIcon.getAttribute('data-aria-paused'));
            this.$soundIconMoving.setAttribute('aria-label', this.$soundIcon.getAttribute('data-aria-paused'));
        }
    }

    manageResize() {
        this.width = this.$soundIcon.getBoundingClientRect().width;
        this.height = this.$soundIcon.getBoundingClientRect().height;
        this.reset();
        if(window.innerWidth >= 1000){
            window.addEventListener("mousemove", this.mouseMove);
            this.$container.addEventListener("mouseenter", this.mouseOver)
            this.$container.addEventListener("mouseleave", this.mouseLeave);
        }
    }

    reset() {
        gsap.set(this.$soundIcon, {scale: 1})
        gsap.set(this.$soundIconMoving, {left: 0, right: 0, top: 0})
        if(window.innerWidth < 1000){
            gsap.set(this.$soundIcon, {scale: 1})
            this.$container.removeEventListener("mouseenter", this.mouseOver);
            this.$container.removeEventListener("mouseleave", this.mouseLeave);
            window.removeEventListener("mousemove", this.mouseMove);
        }
        else{
            gsap.set(this.$soundIconMoving, {scale: 0})
        }
    }
}
